import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MachineComponent } from './machine/machine.component';
import { StatusComponent } from './status/status.component';
import { ModuleComponent } from './module/module.component';
import { MachinetypeComponent } from './machinetype/machinetype.component';
import { TicketviewComponent } from './ticketview/ticketview.component';
import { TicketComponent } from './ticket/ticket.component';
import { CommentComponent } from './comment/comment.component';
import { NavbarComponent } from './navbar/navbar.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TicketCreateComponent } from './ticket-create/ticket-create.component';
import { ReadComponent } from './read/read.component';
import { StateComponent } from './state/state.component';
import { ClientComponent } from './client/client.component';
import { ClientviewComponent } from './clientview/clientview.component';
import { MachineslistviewComponent } from './machineslistview/machineslistview.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MaintenancelistviewComponent } from './maintenancelistview/maintenancelistview.component';
import { MaintenanceCreateComponent } from './maintenance-create/maintenance-create.component';
import { SatlistviewComponent } from './satlistview/satlistview.component';
import { DispatchOrderCreateComponent } from './dispatch-order-create/dispatch-order-create.component';
import { DispatchStateComponent } from './dispatch-state/dispatch-state.component';
import { DispatchOrderComponent } from './dispatch-order/dispatch-order.component';
import { DispatchOrderListviewComponent } from './dispatch-order-listview/dispatch-order-listview.component';
import { TrackingstateComponent } from './trackingstate/trackingstate.component';
import { ClientcreateComponent } from './clientcreate/clientcreate.component';
import { MachinecreateComponent } from './machinecreate/machinecreate.component';
import { RepairreportComponent } from './repairreport/repairreport.component';
import { BossfncComponent } from './bossfnc/bossfnc.component';
import { LogeventlistviewComponent } from './logeventlistview/logeventlistview.component';
import { DashboardComponent as AnotherDashboard } from './dashboard/dashboard.component'; // example if needed

const routes: Routes = [
  // This makes any direct path to '' go to HomeComponent by default
  // or redirect to a specific child if you prefer:
  {
    path: '',
    component: HomeComponent,
    children: [
      // Example default route when hitting '/' (optional)
      // { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      { path: 'dashboard', component: DashboardComponent },
      { path: 'machines', component: MachineComponent },
      { path: 'machines/:id', component: MachineComponent },
      { path: 'statuses/:id', component: StatusComponent },
      { path: 'statuses', component: StatusComponent },
      { path: 'modules', component: ModuleComponent },
      { path: 'modules/:id', component: ModuleComponent },
      { path: 'machinetypes', component: MachinetypeComponent },
      { path: 'machinetypes/:id', component: MachinetypeComponent },
      { path: 'ticketviews', component: TicketviewComponent },
      { path: 'ticketviews/:id', component: TicketviewComponent },
      { path: 'tickets', component: TicketComponent },
      { path: 'tickets/:id', component: TicketComponent },
      { path: 'comments/:id', component: CommentComponent },
      { path: 'comments', component: CommentComponent },
      { path: 'clients', component: ClientComponent },
      { path: 'navbar', component: NavbarComponent },
      { path: 'userprofile', component: UserProfileComponent },
      { path: 'createticket', component: TicketCreateComponent },
      { path: 'createticket/:id', component: TicketCreateComponent },
      { path: 'read', component: ReadComponent },
      { path: 'states/:id', component: StatusComponent },
      { path: 'states', component: StateComponent },
      { path: 'clientviews', component: ClientviewComponent },
      { path: 'clientviews/:id', component: ClientviewComponent },
      { path: 'machineslistview', component: MachineslistviewComponent },
      { path: 'machineslistview/:id', component: MachineslistviewComponent },
      { path: 'maintenances/:id', component: MaintenanceComponent },
      { path: 'maintenancelistview', component: MaintenancelistviewComponent },
      { path: 'createmaintenance', component: MaintenanceCreateComponent },
      { path: 'createmaintenance/:id', component: MaintenanceCreateComponent },
      { path: 'satreports', component: SatlistviewComponent },
      { path: 'dispatchordercreate', component: DispatchOrderCreateComponent },
      { path: 'dispatchorderslist', component: DispatchOrderListviewComponent },
      { path: 'dispatchstate', component: DispatchStateComponent },
      { path: 'dispatchstate/:id', component: DispatchStateComponent },
      { path: 'dispatchorders/:id', component: DispatchOrderComponent },
      { path: 'trackingstate', component: DispatchStateComponent },
      { path: 'trackingstates/:id', component: TrackingstateComponent },
      { path: 'clientcreate', component: ClientcreateComponent },
      { path: 'machinecreate', component: MachinecreateComponent },
      { path: 'repairreport', component: RepairreportComponent },
      { path: 'history', component: LogeventlistviewComponent },
      { path: 'bossfnc', component: BossfncComponent },
        // Login route separate from the HomeComponent layout
  { path: 'login', component: LoginComponent },
  {path: '404', component: LoginComponent},
  {path: '**', redirectTo: '/login'},
    ]
  },



  // Handle ANY unknown path by redirecting to login
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})



export class AppRoutingModule {}
